import { Box } from '@chakra-ui/layout'
import { Button, ButtonGroup } from '@chakra-ui/react'
import { useState } from 'react'

export function Pagination({ nextPage, prevPage, setPage, page, totalPages }) {
  const lastPage = totalPages
  const isFirstPage = page === 1
  const isLastPage = lastPage === page

  const MAX_PAGES = 5 // Número máximo de páginas visíveis antes de exibir o "..."

  const pages = Array.from({ length: lastPage }, (_, index) => index + 1)

  let visiblePages = pages

  if (pages.length > MAX_PAGES) {
    const firstVisiblePage = Math.max(page - Math.floor(MAX_PAGES / 2), 1)
    const lastVisiblePage = Math.min(firstVisiblePage + MAX_PAGES - 1, lastPage)

    visiblePages = pages.slice(firstVisiblePage - 1, lastVisiblePage)
  }

  const handlePageClick = (newPage) => {
    setPage(newPage)
  }

  visiblePages = visiblePages.filter((pageNumber) => {
    return pageNumber > 1 && pageNumber < lastPage
  })

  return (
    <Box
      display={
        isFirstPage && isLastPage ? 'none' : ['none', 'none', 'flex', 'flex']
      }
    >
      <ButtonGroup spacing="2">
        {totalPages !== 1 && (
          <Button
            size="sm"
            onClick={() => handlePageClick(1)}
            variant={1 === page ? 'solid' : 'outline'}
            colorScheme="blue"
          >
            1
          </Button>
        )}

        {visiblePages.map((pageNumber, index) => (
          <Button
            size="sm"
            key={pageNumber}
            onClick={() => handlePageClick(pageNumber)}
            variant={pageNumber === page ? 'solid' : 'outline'}
            colorScheme="blue"
            transition="all 0.1s"
            transform={
              pageNumber === page
                ? 'scale(1.1) translateX(1px)'
                : 'scale(1) translateX(0)'
            }
          >
            {pageNumber}
          </Button>
        ))}

        <Button
          size="sm"
          onClick={() => handlePageClick(lastPage)}
          variant={lastPage === page ? 'solid' : 'outline'}
          colorScheme="blue"
        >
          {lastPage}
        </Button>
      </ButtonGroup>
    </Box>
  )
}
